import './App.css';
import { Route, Routes, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { Container, Nav, Navbar, NavDropdown, Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import axiosInstance from './api/axiosInstance';
import { Hospital } from './routes/Hospital';
import { Portfolio } from './routes/Portfolio';
import { Medicine } from './routes/Medicine';

import { Pharmacy } from './routes/Pharmacy';
import { CryptoMarket } from './routes/CryptoMarket';
import { MdOutlineHealthAndSafety, MdOutlineLocalPharmacy } from "react-icons/md";
import { GiMedicines, GiPsychicWaves, GiSparkles } from "react-icons/gi";
import { IoHomeOutline, IoLogoAndroid } from "react-icons/io5";
import { RiBtcLine, RiAuctionLine, RiToolsFill } from "react-icons/ri";
import { FaDice, FaBuilding, FaRegHospital, FaHammer, FaCloudSun, FaPaperPlane, FaProjectDiagram } from "react-icons/fa";
import { Land } from './routes/Land';
import { BinanceMarket } from './routes/BinanceMarket';
import { BinanceLiquidations } from './routes/BinanceLiquidations';
import { KimpInfo } from './routes/KimpInfo';
import { DevToolbox } from './routes/DevToolbox';
import { DevSkeleton } from './routes/DevSkeleton';
import { DevQRCode } from './routes/DevQRCode';
import { BsQrCode } from 'react-icons/bs';
import './css/custom.css';
// import { OpenWebui } from './routes/OpenWebui';
import { Guestbook } from './routes/Guestbook';
import { TbMessageCircleQuestion } from "react-icons/tb";
import { CiDeliveryTruck } from "react-icons/ci";
import { DeliveryTracker } from './routes/DeliveryTracker';
import { FortuneCookie } from './routes/FortuneCookie';
import { FaChartLine } from "react-icons/fa6";
import { StockMarket } from './routes/StockMarket';
import { ForexMarket } from './routes/ForexMarket';
import { ExchangeRate } from './routes/ExchangeRate';
import { TarotCard } from './routes/TarotCard';
import { BiTrip } from "react-icons/bi";
import { Watrip } from './routes/Watrip';
import { Dominance } from './routes/Dominance';
import { Agent } from './routes/Agent';
import { Auction } from './routes/Auction';
import { CryptoDashboard } from './routes/CryptoDashboard';
import { CryptoNotice } from './routes/CryptoNotice';
import { WeatherBoard } from './routes/WeatherBoard';
import DiaryBoard from './routes/DiaryBoard';
import DiaryDetail from './routes/DiaryDetail';
import DiaryWrite from './routes/DiaryWrite';
import Receipts from './routes/Receipts';
import { FaReceipt } from "react-icons/fa";
import { RiFilePaper2Line } from "react-icons/ri";
import ProtectedRoute from './components/ProtectedRoute';
import WaGgu from './routes/WaGgu';
import { FaDrawPolygon } from 'react-icons/fa';
import FloatingChat from './components/FloatingChat';
import Wageundam from './routes/Wageundam';
import Wafit from './routes/Wafit';


// Auth
import LoginModal from './components/LoginModal';
import SignUpModal from './components/SignUpModal';
import authService from './services/authService';
import useAuthStore from './stores/authStore';

function App() {
  const location = useLocation();
  const [navbarState, setNavbarState] = useState(false);
  let navigate = useNavigate();

  // 페이지뷰 추적
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  // 메뉴 클릭 공통 함수
  const trackMenuClick = (menuName, path) => {
    if (window.gtag) {
      window.gtag('event', 'menu_click', {
        menu_name: menuName,
        page_path: path,
      });
    }
  };

  const fnObj = {
    menuCollapse() {
      setNavbarState(false);
    }
  };

  // 모달 관련 상태
  const [showModal, setShowModal] = useState(false);
  const [emailFrom, setEmailFrom] = useState("");
  const [emailTitle, setEmailTitle] = useState("");
  const [emailContents, setEmailContents] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // Auth States
  const { isAuthenticated: isLoggedIn, user } = useAuthStore();
  const userNickname = user?.nickname || user?.sub || '';
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);

  // Auth Logic - Silent Refresh on Mount
  useEffect(() => {
    const initAuth = async () => {
      await authService.silentRefresh();
    };
    initAuth();

    // 멀티 탭 로그인/로그아웃 동기화
    const handleStorageChange = (e) => {
      if (e.key === 'wablog_auth_event') {
        if (e.newValue?.startsWith('login')) {
          authService.silentRefresh(); // 다른 탭에서 로그인 시 현재 탭도 갱신
        } else if (e.newValue?.startsWith('logout')) {
          useAuthStore.getState().logout(); // 다른 탭에서 로그아웃 시 현재 탭도 로그아웃
        }
      }
    };

    // 세션 만료 이벤트 수신
    const handleSessionExpired = () => {
      setShowLoginModal(true);
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('wablog_session_expired', handleSessionExpired);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('wablog_session_expired', handleSessionExpired);
    };
  }, []);

  const handleClose = () => {
    setShowModal(false);
    setAlertMsg("");
    setSuccess(false);
    setEmailFrom("");
    setEmailTitle("");
    setEmailContents("");
  };

  const sendEmail = async () => {
    if (!emailFrom || !emailTitle || !emailContents) {
      setAlertType("danger");
      setAlertMsg("모든 필드를 입력해주세요.");
      return;
    }

    setLoading(true);
    setAlertMsg("");

    try {
      const response = await axiosInstance.post("email/send", { emailFrom, emailTitle, emailContents });
      const result = response.data;

      if (result[0]?.accepted?.length > 0) {
        setAlertType("success");
        setAlertMsg("메일이 정상적으로 전송되었습니다!");
        setSuccess(true);
      } else {
        setAlertType("danger");
        setAlertMsg("메일 전송에 실패했습니다. 잠시 후 다시 시도해주세요.");
      }
    } catch (err) {
      setAlertType("danger");
      setAlertMsg("메일 전송에 실패했습니다. 잠시 후 다시 시도해주세요.");
    }

    setLoading(false);
  };

  return (
    <div className="App">
      {/* ✅ Navbar */}
      <Navbar expand="lg" className="bg-body-tertiary custom-navbar" sticky="top">
        <Container>
          <Navbar.Brand
            onClick={() => {
              trackMenuClick("Home(Logo)", "/");
              navigate('/');
            }}
          >
            <img src="/pepe.png" alt="로고" style={{ height: "30px", marginRight: "10px" }} />
            와! 블로그
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setNavbarState(!navbarState)} />
          <Navbar.Collapse id="basic-navbar-nav" in={navbarState}>
            <Nav className="mx-auto">

              {/* Home */}
              <Nav.Link onClick={() => { trackMenuClick("Home", "/"); navigate('/'); fnObj.menuCollapse(); }}>
                {<IoHomeOutline />}&nbsp;Home
              </Nav.Link>

              {/* 의료 */}
              <NavDropdown title={<><MdOutlineHealthAndSafety />&nbsp;의료</>} id="board-dropdown" className="custom-dropdown">
                <NavDropdown.Item onClick={() => { trackMenuClick("의료 - 응급실", "/heahth/hospital"); navigate("/heahth/hospital"); fnObj.menuCollapse(); }}>
                  {<FaRegHospital />}&nbsp;응급실
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("의료 - 약국", "/heahth/pharmacy"); navigate("/heahth/pharmacy"); fnObj.menuCollapse(); }}>
                  {<MdOutlineLocalPharmacy />}&nbsp;약국
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("의료 - 약", "/heahth/medicine"); navigate("/heahth/medicine"); fnObj.menuCollapse(); }}>
                  {<GiMedicines />}&nbsp;약
                </NavDropdown.Item>
              </NavDropdown>

              {/* 크립토 */}
              <NavDropdown title={<><RiBtcLine />&nbsp;크립토</>} id="board-dropdown" className="custom-dropdown">
                <NavDropdown.Item onClick={() => { trackMenuClick("크립토 - 대시보드", "/crypto/crypto-dashboard"); navigate("/crypto/crypto-dashboard"); fnObj.menuCollapse(); }}>
                  {<RiBtcLine />}&nbsp;대시보드
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("크립토 - 업비트", "/crypto/crypto-market"); navigate("/crypto/crypto-market"); fnObj.menuCollapse(); }}>
                  {<RiBtcLine />}&nbsp;업비트
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("크립토 - 김프정보", "/crypto/kimp-info"); navigate("/crypto/kimp-info"); fnObj.menuCollapse(); }}>
                  {<RiBtcLine />}&nbsp;김프정보
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("크립토 - 롱/숏 청산", "/crypto/binance-liquidations"); navigate("/crypto/binance-liquidations"); fnObj.menuCollapse(); }}>
                  {<RiBtcLine />}&nbsp;롱/숏 청산
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("크립토 - 도미넌스", "/crypto/dominance"); navigate("/crypto/dominance"); fnObj.menuCollapse(); }}>
                  {<RiBtcLine />}&nbsp;도미넌스
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("크립토 - 늬우스", "/crypto/crypto-notice"); navigate("/crypto/crypto-notice"); fnObj.menuCollapse(); }}>
                  {<RiBtcLine />}&nbsp;늬우스
                </NavDropdown.Item>
              </NavDropdown>

              {/* 시장 */}
              <NavDropdown title={<><FaChartLine />&nbsp;시장</>} id="board-dropdown" className="custom-dropdown">
                <NavDropdown.Item onClick={() => { trackMenuClick("시장 - 환율", "/stock/exchange-rate"); navigate("/stock/exchange-rate"); fnObj.menuCollapse(); }}>
                  {<FaChartLine />}&nbsp;환율
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("시장 - 주식시황", "/stock/stock-market"); navigate("/stock/stock-market"); fnObj.menuCollapse(); }}>
                  {<FaChartLine />}&nbsp;주식시황
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("시장 - 외환시황", "/stock/forex-market"); navigate("/stock/forex-market"); fnObj.menuCollapse(); }}>
                  {<FaChartLine />}&nbsp;외환시황
                </NavDropdown.Item>
              </NavDropdown>

              {/* 기상정보 */}
              <Nav.Link onClick={() => { trackMenuClick("기상정보", "/weather"); navigate('/weather'); fnObj.menuCollapse(); }}>
                {<FaCloudSun />}&nbsp;기상정보
              </Nav.Link>

              {/* AI */}
              <NavDropdown title={<><IoLogoAndroid />&nbsp;AI</>} id="board-dropdown" className="custom-dropdown">
                <NavDropdown.Item onClick={() => { trackMenuClick("AI - 와!에이전트", "/ai/agent"); navigate("/ai/agent"); fnObj.menuCollapse(); }}>
                  {<IoLogoAndroid />}&nbsp;와!에이전트
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("AI - 와근담", "/ai/wageundam"); navigate("/ai/wageundam"); fnObj.menuCollapse(); }}>
                  {<IoLogoAndroid />}&nbsp;와근담
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("AI - 와핏", "/ai/wafit"); navigate("/ai/wafit"); fnObj.menuCollapse(); }}>
                  {<GiSparkles />}&nbsp;와핏
                </NavDropdown.Item>
                {/* <NavDropdown.Item onClick={() => { trackMenuClick("AI - LLM", "/ai/llm"); navigate("/ai/llm"); fnObj.menuCollapse(); }}>
                  {<IoLogoAndroid />}&nbsp;LLM
                </NavDropdown.Item> */}
              </NavDropdown>

              {/* 택배 */}
              <Nav.Link onClick={() => { trackMenuClick("택배", "/delivery"); navigate('/delivery'); fnObj.menuCollapse(); }}>
                {<CiDeliveryTruck />}&nbsp;택배
              </Nav.Link>

              {/* 사주 */}
              <NavDropdown title={<><GiPsychicWaves />&nbsp;사주</>} id="board-dropdown" className="custom-dropdown">
                <NavDropdown.Item onClick={() => { trackMenuClick("사주 - 포춘쿠키", "/psychic/fortune-cookie"); navigate("/psychic/fortune-cookie"); fnObj.menuCollapse(); }}>
                  {<GiPsychicWaves />}&nbsp;포춘쿠키
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("사주 - 타로카드", "/psychic/tarot-card"); navigate("/psychic/tarot-card"); fnObj.menuCollapse(); }}>
                  {<GiPsychicWaves />}&nbsp;타로카드
                </NavDropdown.Item>
              </NavDropdown>

              {/* 부루마블 */}
              <NavDropdown title={<><FaDice />&nbsp;부루마블</>} id="board-dropdown" className="custom-dropdown">
                <NavDropdown.Item onClick={() => { trackMenuClick("부루마블 - 와!르르", "/trip/watrip"); navigate("/trip/watrip"); fnObj.menuCollapse(); }}>
                  {<BiTrip />}&nbsp;와!르르
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("부루마블 - 경매", "/bluemarble/auction"); navigate("/bluemarble/auction"); fnObj.menuCollapse(); }}>
                  {<RiAuctionLine />}&nbsp;경매
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("부루마블 - 와방", "/bluemarble/land"); navigate("/bluemarble/land"); fnObj.menuCollapse(); }}>
                  {<FaBuilding />}&nbsp;와방
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("부루마블 - 와꾸", "/bluemarble/waggu"); navigate("/bluemarble/waggu"); fnObj.menuCollapse(); }}>
                  {<FaDrawPolygon />}&nbsp;와꾸
                </NavDropdown.Item>
              </NavDropdown>

              {/* 방명록 */}
              <Nav.Link onClick={() => { trackMenuClick("방명록", "/guestbook"); navigate('/guestbook'); fnObj.menuCollapse(); }}>
                {<TbMessageCircleQuestion />}&nbsp;방명록
              </Nav.Link>

              {/* jdsys */}
              <NavDropdown title={<><RiFilePaper2Line />&nbsp;jdsys</>} id="board-dropdown" className="custom-dropdown">
                <NavDropdown.Item onClick={() => { trackMenuClick("jdsys - 지결서", "/jdsys/receipts"); navigate("/jdsys/receipts"); fnObj.menuCollapse(); }}>
                  {<FaReceipt />}&nbsp;지결서
                </NavDropdown.Item>
              </NavDropdown>

              {/* 개발연장 */}
              <NavDropdown title={<><RiToolsFill />&nbsp;개발연장</>} id="board-dropdown" className="custom-dropdown">
                <NavDropdown.Item onClick={() => { trackMenuClick("개발연장 - 제련도구", "/dev/tools"); navigate("/dev/tools"); fnObj.menuCollapse(); }}>
                  {<FaHammer />}&nbsp;제련도구
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("개발연장 - 뼈대도구", "/dev/skeleton"); navigate("/dev/skeleton"); fnObj.menuCollapse(); }}>
                  {<FaProjectDiagram />}&nbsp;뼈대도구
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => { trackMenuClick("개발연장 - QR코드", "/dev/qrcode"); navigate("/dev/qrcode"); fnObj.menuCollapse(); }}>
                  {<BsQrCode />}&nbsp;QR코드
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav className="ms-lg-3">
              {isLoggedIn ? (
                <div className="d-flex align-items-center gap-2 justify-content-end w-100 flex-wrap">
                  <span className="text-dark fw-bold me-2" style={{ fontSize: '0.88rem' }}>{userNickname}님</span>
                  <Button
                    variant="link"
                    className="text-decoration-none d-flex align-items-center gap-1 navbar-auth-btn-logout"
                    onClick={() => authService.logout()}
                  >
                    🚪 로그아웃
                  </Button>
                </div>
              ) : (
                <div className="d-flex align-items-center gap-2 justify-content-end w-100 flex-wrap">
                  <Button
                    variant="link"
                    className="text-decoration-none d-flex align-items-center gap-1 navbar-auth-btn-login"
                    onClick={() => setShowLoginModal(true)}
                  >
                    🔐 로그인
                  </Button>
                  <Button
                    variant="link"
                    className="text-decoration-none d-flex align-items-center gap-1 navbar-auth-btn-signup"
                    onClick={() => setShowSignUpModal(true)}
                  >
                    ✨ 회원가입
                  </Button>
                </div>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Routes */}
      <Routes>
        <Route path="/" element={<DiaryBoard />} />
        <Route path="/diary/write" element={<ProtectedRoute allowedRoles={['admin']}><DiaryWrite /></ProtectedRoute>} />
        <Route path="/diary/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><DiaryWrite /></ProtectedRoute>} />
        <Route path="/diary/:id" element={<DiaryDetail />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/heahth/hospital" element={<Hospital />} />
        <Route path="/heahth/medicine" element={<Medicine />} />
        <Route path="/heahth/pharmacy" element={<Pharmacy />} />
        <Route path="/finedust" element={<Navigate to="/weather" replace />} />
        <Route path="/weather" element={<WeatherBoard />} />
        <Route path="/crypto/crypto-dashboard" element={<CryptoDashboard />} />
        <Route path="/crypto/crypto-market" element={<CryptoMarket />} />
        <Route path="/crypto/binance-market" element={<BinanceMarket />} />
        <Route path="/crypto/binance-liquidations" element={<BinanceLiquidations />} />
        <Route path="/crypto/dominance" element={<Dominance />} />
        <Route path="/crypto/crypto-notice" element={<CryptoNotice />} />
        <Route path="/crypto/kimp-info" element={<KimpInfo />} />
        <Route path="/ai/agent" element={<Agent />} />
        <Route path="/ai/wageundam" element={<Wageundam />} />
        <Route path="/ai/wafit" element={<Wafit />} />
        {/* <Route path="/ai/llm" element={<OpenWebui />} /> */}
        <Route path="/guestbook" element={<Guestbook />} />
        <Route path="/delivery" element={<DeliveryTracker />} />
        <Route path="/psychic/fortune-cookie" element={<FortuneCookie />} />
        <Route path="/psychic/tarot-card" element={<TarotCard />} />
        <Route path="/stock/stock-market" element={<StockMarket />} />
        <Route path="/stock/forex-market" element={<ForexMarket />} />
        <Route path="/stock/exchange-rate" element={<ExchangeRate />} />
        <Route path="/trip/watrip" element={<Watrip />} />
        <Route path="/bluemarble/auction" element={<Auction />} />
        <Route path="/bluemarble/land" element={<Land />} />
        <Route path="/bluemarble/waggu" element={<WaGgu />} />
        <Route path="/jdsys/receipts" element={<ProtectedRoute><Receipts /></ProtectedRoute>} />
        <Route path="/dev/tools" element={<DevToolbox />} />
        <Route path="/dev/skeleton" element={<DevSkeleton />} />
        <Route path="/dev/qrcode" element={<DevQRCode />} />
        <Route path="*" element={<div>없는 페이지예요.</div>} />
      </Routes>

      {/* Footer */}
      <footer className="custom-footer mt-5">
        <div className="container text-center">
          <p className="mb-1 text-secondary" style={{ letterSpacing: '0.02em' }}>
            © 2026 All Rights Reserved.
          </p>
          <p className="mb-0">
            Designed & Crafted with ❤️ by{" "}
            <span className="footer-brand-name" onClick={() => setShowModal(true)}>
              wajok
            </span>
          </p>
        </div>
      </footer>

      {/* 이메일 모달 */}
      <Modal show={showModal} onHide={handleClose} centered contentClassName="rounded-4 shadow-lg border-0 bg-white" className="custom-letter-modal">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold d-flex align-items-center gap-2 text-dark fs-5 mt-2" style={{ letterSpacing: '-0.02em' }}>
            📮 wajok에게 편지 보내기
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          {alertMsg && <Alert variant={alertType} className="rounded-3 py-2 small">{alertMsg}</Alert>}
          
          {success ? (
            <div className="text-center py-4 my-2">
              <div className="fs-1 mb-3 animate-bounce">📬</div>
              <h5 className="fw-bold text-dark mb-2">편지가 무사히 도착했습니다!</h5>
              <p className="text-secondary small mb-0 px-3">
                소중한 시간 내어 의견을 남겨주셔서 대단히 감사합니다.<br />
                남겨주신 메시지는 꼼꼼히 읽고 검토하겠습니다.
              </p>
            </div>
          ) : (
            <>
              <p className="text-muted small mb-4 px-1">
                건의사항, 버그 제보, 혹은 따뜻한 응원의 한 마디를 적어 보내주세요.
              </p>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold text-secondary small d-flex align-items-center gap-1">
                    📧 답장 받을 이메일
                  </Form.Label>
                  <Form.Control 
                    type="email" 
                    value={emailFrom} 
                    onChange={e => setEmailFrom(e.target.value)} 
                    placeholder="your@email.com" 
                    className="py-2.5 rounded-3 border-light-subtle shadow-sm"
                    style={{ fontSize: '0.9rem' }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold text-secondary small d-flex align-items-center gap-1">
                    ✏️ 편지 제목
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    value={emailTitle} 
                    onChange={e => setEmailTitle(e.target.value)} 
                    placeholder="제목을 입력해 주세요" 
                    className="py-2.5 rounded-3 border-light-subtle shadow-sm"
                    style={{ fontSize: '0.9rem' }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold text-secondary small d-flex align-items-center gap-1">
                    💬 메시지 내용
                  </Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows={4} 
                    value={emailContents} 
                    onChange={e => setEmailContents(e.target.value)} 
                    placeholder="wajok에게 전할 내용을 입력해 주세요..." 
                    className="py-2 rounded-3 border-light-subtle shadow-sm"
                    style={{ fontSize: '0.9rem', resize: 'none' }}
                  />
                </Form.Group>
              </Form>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 pb-4 justify-content-center gap-2">
          <Button 
            variant="light" 
            onClick={handleClose}
            className="px-4 py-2 text-secondary fw-semibold rounded-pill border-0"
            style={{ fontSize: '0.88rem', background: '#f1f5f9' }}
          >
            {success ? "확인" : "취소"}
          </Button>
          {!success && (
            <Button 
              variant="primary" 
              onClick={sendEmail} 
              disabled={loading}
              className="px-4 py-2 fw-semibold rounded-pill border-0 d-flex align-items-center gap-2 shadow-sm"
              style={{ fontSize: '0.88rem', background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)' }}
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>
                  <FaPaperPlane size={12} />
                  <span>전송하기</span>
                </>
              )}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Auth Modals */}
      <LoginModal
        show={showLoginModal}
        onHide={() => setShowLoginModal(false)}
        onLoginSuccess={() => { }}
      />
      <SignUpModal
        show={showSignUpModal}
        onHide={() => setShowSignUpModal(false)}
      />
      <FloatingChat />
    </div>
  );
}

export default App;